module.exports = __webpack_public_path__ + "static/macarons_gifts-c7601509d02665169ba41f8ad520af03.jpg";